export default {
    API_BASE: 'https://d3gi8gwohj2rn5.cloudfront.net/api/mobileKlinik/'
}